export default __webpack_public_path__ + "static/media/gallery5.9d8c7d49.jpg";